interface SwitchProps {
  switchCase: string;
  children: JSX.Element[];
}

const Switch: React.FC<SwitchProps> = ({ switchCase, children }) => {
  const defaultResult = children.find(child => child.props.default) || children[0];
  const result = children.find(child => child.props.value === switchCase);

  return result || defaultResult;
};

export default Switch;
